import { texts } from './texts'

export interface KnowledgeDatabaseInfo {
  tenantId: string
  name: string
  description: string
}

export const knowledgeDatabases: KnowledgeDatabaseInfo[] = [
  { tenantId: 'CCUK', ...texts.databases.internalQa },
  { tenantId: 'CUUK', ...texts.databases.systemAndWorkflows },
  { tenantId: 'CHUK', ...texts.databases.escalation },
  { tenantId: 'CAUK', ...texts.databases.aftercare },
  { tenantId: 'CCTML', ...texts.databases.tomorrowland },
]

export function getKnowledgeDatabaseName(tenantId: string): string | undefined {
  return knowledgeDatabases.find(db => db.tenantId === tenantId)?.name
}
